var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnPaginationRightHover({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "quoabnhora"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.309804 0 0 0 0 0.372549 0 0 0 0 0.847059 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#CCD9FF",
    fillRule: "nonzero",
    width: 20,
    height: 20,
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#quoabnhora)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.051 10.759a.75.75 0 0 0 .06-.943l-.06-.075-3-3.25a.75.75 0 0 0-1.162.945l.06.073 2.531 2.741-2.531 2.741a.75.75 0 0 0-.023.992l.065.068a.75.75 0 0 0 .992.023l.068-.065 3-3.25z",
    fill: "#333",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnPaginationRightHover);
export default __webpack_public_path__ + "static/media/btn-pagination-right-hover.931064c0a2e1c2c1a83908c294286c3a.svg";
export { ForwardRef as ReactComponent };